"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _UserAvatar = _interopRequireDefault(require("../../User/UserAvatar"));

var _UserName = _interopRequireDefault(require("../../User/UserName"));

/**
 * Author display component with avatar and username.
 * Renders in the meta section of an IdeaCard.
 */
var IdeaCardAuthor = function IdeaCardAuthor(_ref) {
  var author = _ref.author;
  return (0, _preact.h)("div", {
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, (0, _preact.h)(_UserAvatar.default, {
    user: author,
    extraClass: "avatar avatar--S",
    showRank: true,
    disablePopup: true
  }), (0, _preact.h)(_UserName.default, {
    user: author,
    extraClass: "pipeline__idea-username"
  }));
};

var _default = IdeaCardAuthor;
exports.default = _default;